import { Fragment, useState } from "react";
import { Button, Dialog, Transition, DialogBackdrop } from "@headlessui/react";
import InputField from "components/fields/InputField";
import { useTranslation } from "react-i18next";
import store from "redux/store";

import {
  LOGIN_SUCCESS,
  LOGOUT,
  HIDE_MODAL,
  MESSAGE_INFO,
  MESSAGE_SUCCES,
  SET_USER,
} from "actions/types";
import { showLoader, hideLoader } from "actions/types";
import Company from "api/Company";

export default function CompanyConnectWithCodeView(props) {
  const { t, i18n } = useTranslation("modals");
  const [open, setOpen] = useState(true);

  const saveEvent = (event) => {
    event.preventDefault();
    connectCompanyByCode(event.target.elements.connectCode.value);
  };

  const handleClose = () => {
    setOpen(false);
    if (props.onHideEvent) {
      props.onHideEvent();
    }
  };

  const connectCompanyByCode = async (data) => {
    try {
      store.dispatch(showLoader());
      const response = await Company.connectCompanyByCode(data);
      store.dispatch({ type: HIDE_MODAL });
      store.dispatch({
        type: MESSAGE_SUCCES,
        message: "Bedrijf gekoppeld door koppelcode",
        header: "Bedrijf connection",
      });
      if (props.modalview.saveEvent) {
        props.modalview.saveEvent();
      }
      store.dispatch(hideLoader());
    } catch (error) {
      if (error.response.status == 403 && error.response.data.data) {
        store.dispatch({
          type: MESSAGE_INFO,
          message: error.response.data.data.data,
          header: "Bedrijf connection",
        });
      }
      store.dispatch(hideLoader());
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={handleClose}>
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-black/80 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="overflow-y-auto fixed inset-0 z-10 w-screen">
          <div className="flex justify-center items-end p-4 min-h-full text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="overflow-hidden relative text-left bg-white shadow-xl transition-all transform sm:my-8 sm:w-full sm:max-w-lg">
                <form onSubmit={saveEvent}>
                  <div className="px-4 pt-5 pb-4 sm:p-6">
                    <div className="flex items-center">
                      <div className="flex flex-shrink-0 justify-center items-center mx-auto w-12 h-12 bg-blue-50 rounded-full sm:mx-0 sm:h-10 sm:w-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-blue-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                          />
                        </svg>
                      </div>
                      <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-lg font-medium leading-6 text-gray-900"
                        >
                          {props.modalview.header}
                        </Dialog.Title>
                      </div>
                    </div>

                    <div className="mt-4">
                      <p className="mb-4 text-sm text-gray-500">
                        {props.modalview.message}
                      </p>
                      <div className="mb-4">
                        <label
                          htmlFor="connectCode"
                          className="block mb-6 text-sm font-medium text-gray-700"
                        >
                          {t("companyconnectwithcode.title")}
                        </label>
                        <InputField
                          type="text"
                          lbl=""
                          name="connectCode"
                          id="connectCode"
                          placeholder=""
                        />
                        <p className="mt-2 text-sm text-gray-500">
                          De koppelcode heb je ontvangen in de e-mail. Deze moet
                          worden verstuurd door de eigenaar van het bedrijf.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="gap-3 px-4 py-3 bg-gray-50 sm:px-6 sm:flex sm:flex-row-reverse">
                    <Button type="submit" className="btn-primary">
                      {t("companyconnectwithcode.save")}
                    </Button>
                    <Button
                      type="button"
                      className="btn-secondary"
                      onClick={handleClose}
                    >
                      {t("companyconnectwithcode.cancel")}
                    </Button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
